import { languageChoices } from './zoneConsts'

/**
 * Get language libelle with id
 * @param idLanguage
 */
export const getLanguageLibelle = (idLanguage: string) => {
	const language = languageChoices.find((choice) => choice.id === idLanguage)
	return language ? language.libelle : idLanguage
}